module.exports = __webpack_public_path__ + "static/jordan-peterson-20a455bb4426256f71b1354c5d1e308a.png";